import {datadogRum} from '@datadog/browser-rum';

const DatadogInit = () => {
  // Datadog RUM initialization
  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENTTOKEN,
    site: 'datadoghq.com',
    service: 'marketing-site',
    env: process.env.ENVIRONMENT,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: '1.0.0',
    sessionSampleRate: process.env.ENVIRONMENT === 'production' ? 1 : 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  });

  // Session Replay is disabled via sessionReplaySampleRate: 0 because of the Datadog plan pricing.
  // Re-enable this call along with a non-zero sessionReplaySampleRate to record replays again.
  // datadogRum.startSessionReplayRecording();
};

export default DatadogInit;
